module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-262.20fa217.woff2";